import { render, staticRenderFns } from "./EmpenhoList.vue?vue&type=template&id=6bf60765&scoped=true"
import script from "./EmpenhoList.vue?vue&type=script&lang=js"
export * from "./EmpenhoList.vue?vue&type=script&lang=js"
import style0 from "./EmpenhoList.vue?vue&type=style&index=0&id=6bf60765&prod&scoped=true&lang=css"
import style1 from "./EmpenhoList.vue?vue&type=style&index=1&id=6bf60765&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf60765",
  null
  
)

export default component.exports